<template>
  <div class="row">
    <div class="col-md-12">
      <textarea
        class="form-control"
        placeholder="File Description"
        v-model="fileData.description"
        rows="5"
      ></textarea>
      <div class="text-danger" v-if="errors.description">
        {{ errors.description[0] }}
      </div>
    </div>
    <div class="col-md-12">
      <div
        class="file-drop-area"
        @dragover.prevent
        @dragenter.prevent
        @drop.prevent="handleFileDrop"
        @click="selectFile"
      >
        <input
          type="file"
          ref="fileInput"
          style="display: none"
          multiple
          @change="handleFileSelect"
          accept="/*"
        />
        <div class="text-danger" v-if="errors.files">
          {{ errors.files[0] }}
        </div>
        <span>Drag & Drop files here or click to browse</span>
      </div>
    </div>
    <div class="col-md-12 mt-3">
      <div class="file-preview-grid">
        <div
          v-for="(file, index) in fileData.files"
          :key="index"
          class="file-preview-item"
        >
          <img :src="file.preview" alt="Image preview" class="img-thumbnail" />
          <div class="file-info">
            <span>{{ file.name }}</span>
            <button class="btn btn-sm btn-danger" @click="removeFile(index)">
              Remove
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 mt-3">
      <div class="d-flex justify-content-end">
        <button
          class="btn btn-success"
          @click="saveFiles"
          :disabled="isLoading"
        >
          <span
            v-if="isLoading"
            class="spinner-border spinner-border-sm"
          ></span>
          Save Files
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";

export default {
  props: {
    leadId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      fileData: {
        description: "",
        files: [], // Array to hold multiple files with previews
      },
      errors: {},
    };
  },
  mounted() {
    const fullPath = this.$route.fullPath;
    const lastPart = fullPath.split("/").filter(Boolean).pop();
    this.currentPath = lastPart;
  },
  methods: {
    handleFileDrop(event) {
      const files = Array.from(event.dataTransfer.files);
      this.addFiles(files);
    },
    selectFile() {
      this.$refs.fileInput.click();
    },
    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      this.addFiles(files);
    },
    addFiles(files) {
      files.forEach((file) => {
        if (!this.fileData.files.some((f) => f.name === file.name)) {
          this.fileData.files.push({
            file,
            name: file.name,
            preview: URL.createObjectURL(file),
          });
        }
      });
    },
    removeFile(index) {
      URL.revokeObjectURL(this.fileData.files[index].preview);
      this.fileData.files.splice(index, 1);
    },
    async saveFiles() {
      if (!this.fileData.files.length) {
        this.$toast.error("Please select at least one file.");
        return;
      }

      this.isLoading = true;
      const formData = new FormData();
      formData.append("lead_id", this.leadId);
      formData.append("description", this.fileData.description);
      formData.append(
        "key_account",
        this.currentPath == "key-account-details" ? "Y" : "N"
      );

      this.fileData.files.forEach((fileData, index) => {
        formData.append(`files[${index}]`, fileData.file);
      });

      try {
        const response = await http.post(
          "/store-leads-details-files-info",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        this.$emitter.emit("form-submitted");
        this.errors = {};
        this.$toast.success(response.data.message);
        this.resetForm();
      } catch (error) {
        this.errors = error.response?.data?.errors || {};
        // this.$toast.error("Failed to upload files.");
        for (const key in this.errors) {
          if (this.errors.hasOwnProperty(key)) {
            this.errors[key].forEach((message) => {
              this.$toast.error(message);
            });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    resetForm() {
      this.fileData.description = "";
      this.fileData.files.forEach((fileData) => {
        URL.revokeObjectURL(fileData.preview);
      });
      this.fileData.files = [];
    },
  },
};
</script>

<style scoped>
.file-drop-area {
  border: 2px dashed #ddd;
  padding: 20px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  color: #aaa;
}
.file-drop-area:hover {
  border-color: #007bff;
  color: #007bff;
}
.file-preview-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.file-preview-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  text-align: center;
}
.file-preview-item img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 5px;
}
.file-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.file-info button {
  margin-top: 5px;
}
</style>
